import initBanner from './components/case-study/banner';

const bannerEl = document.querySelector('.js-banner');

if (bannerEl) {
    initBanner(bannerEl);
}
